import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc StatusOfClaim defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { StatusOfClaimService } from 'services/statusOfClaim';
 *
 * // create service instance and send/cancel request
 * const statusOfClaimService = new StatusOfClaimService();
 * const result = await statusOfClaimService.fetchData( '<user-id>' ); // fetch data
 * statusOfClaimService.cancel(); // cancel an active request
 */
export class StatusOfClaimService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
